module.exports = __webpack_public_path__ + "static/media/squared.3038a918.jpg";